import { render, staticRenderFns } from "./APIManagement.vue?vue&type=template&id=18c49fab&scoped=true"
import script from "./APIManagement.js?vue&type=script&lang=js&external"
export * from "./APIManagement.js?vue&type=script&lang=js&external"
import style0 from "./APIManagement.vue?vue&type=style&index=0&id=18c49fab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c49fab",
  null
  
)

export default component.exports